module.exports = __webpack_public_path__ + "static/media/insta-11.956fd0f8.png";